import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import FieldRow from '../../../../F22/common/FieldRow';
import { calcularPersona } from '../formulas';

/**
 * Persona, líneas 25 a 53 del F22 AT 2026: IGC según tabla, restitución, créditos (primero
 * los que no dan devolución, después los que sí) e IGC a declarar. El resultado único del
 * F22, que junta este IGC con el IDPC de la empresa y los PPM, se arma en la liquidación.
 */
const PersonaImpuestoSection = ({ data }) => {
  const c = calcularPersona(data);
  return (
    <SectionContainer title="Impuesto Global Complementario" subtitle="Persona · líneas 25 a 53 del F22">
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Impuesto</h4>
        <FieldRow label="Línea 25 · IGC según tabla" code="157" sign="(+)" value={c[157]} computed />
        <FieldRow label="Línea 29 · Débito fiscal por restitución del crédito por IDPC" code="1035" sign="(+)" value={c[1035]} computed />
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Créditos sin derecho a devolución</h4>
        <FieldRow label="Línea 34 · Crédito proporcional por rentas exentas" code="136" sign="(-)" value={c[136]} computed />
        <FieldRow label="Línea 35 · Crédito por impuesto tasa adicional" code="176" sign="(-)" value={c[176]} computed />
        <FieldRow label="Línea 37 · Crédito por IDPC sin derecho a devolución" code="608" sign="(-)" value={c[608]} computed />
        <FieldRow label="Línea 41 · Crédito por gastos en educación" code="895" sign="(-)" value={c[895]} computed />
        <FieldRow label="Línea 49 · Crédito por impuestos soportados en el exterior" code="746" sign="(-)" value={c[746]} computed />
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Créditos con derecho a devolución</h4>
        <FieldRow label="Línea 46 · Crédito por impuesto único de segunda categoría" code="162" sign="(-)" value={c[162]} computed />
        <FieldRow label="Línea 48 · Crédito por IDPC con derecho a devolución" code="610" sign="(-)" value={c[610]} computed />
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Resultado del IGC</h4>
        <FieldRow label="Línea 52 · IGC determinado" code="304" sign="(=)" value={c[304]} computed className="f22-field-subtotal" />
        <FieldRow label="Línea 53 · IGC a declarar" code="31" sign="(+)" value={c[31]} computed className="f22-field-total" />
        <FieldRow label="Línea 97 · Remanente de crédito del impuesto único (devolvible)" code="119" value={c[119]} computed />
        <FieldRow label="Línea 97 · Remanente de crédito por IDPC (devolvible)" code="116" value={c[116]} computed />
        <FieldRow label="Línea 92 · Mayor retención de impuesto único solicitada" code="54" value={c[54]} computed />
        <p className="f22-hint">Los remanentes devolvibles y la mayor retención se descuentan en la liquidación del F22, junto con el IDPC de la empresa y los PPM.</p>
      </div>
    </SectionContainer>
  );
};

export default PersonaImpuestoSection;
